
<Transition
  :name="n('--fade')"
  :duration="animationDuration"
>
  <div
    v-show="visible"
    ref="overlay"
    :class="overlayClassName"
    :style="overlayStyle"
    @click="handleClickOverlay"
  >
    <slot />
  </div>
</Transition>
